export default function animateLetters(selector = '.animate-letters') {
  const targets = document.querySelectorAll(selector);
  if (!targets.length) return;

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  targets.forEach(el => {
    if (el.dataset.animated === 'true') return;

    const text = el.textContent.trim();
    el.setAttribute('aria-label', text);
    el.textContent = '';

    const words = text.split(/(\s+)/); // keep spaces
    const frag = document.createDocumentFragment();

    let charIndex = 0;
    const maxStaggerMs = 900;
    const perCharDelayMs = 35;

    words.forEach(word => {
      if (word.trim() === '') {
        frag.appendChild(document.createTextNode(word));
        return;
      }

      const wordSpan = document.createElement('span');
      wordSpan.className = 'word';

      Array.from(word).forEach(ch => {
        const span = document.createElement('span');
        span.className = 'char';
        span.textContent = ch;

        if (!prefersReduced) {
          const delay = Math.min(charIndex * perCharDelayMs, maxStaggerMs);
          span.style.transitionDelay = delay + 'ms';
        }

        wordSpan.appendChild(span);
        charIndex++;
      });

      frag.appendChild(wordSpan);
    });

    el.appendChild(frag);
    el.dataset.animated = 'true';
  });

  if (prefersReduced) {
    targets.forEach(el => el.classList.add('is-visible'));
    return;
  }

  const io = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.2,
    rootMargin: '0px 0px -10% 0px'
  });

  targets.forEach(el => io.observe(el));
}
